<nb-card class="csv-import-dialog" style="min-width: 560px; max-width: 700px; max-height: 85vh; overflow-y: auto;">
  <nb-card-header>
    <h4>Import Global Products from CSV</h4>
  </nb-card-header>

  <nb-card-body>

    <!-- Instructions -->
    <div class="alert alert-info mb-3" *ngIf="!result">
      <strong>How to import:</strong>
      <ol class="mb-1 mt-1">
        <li>Download the CSV template below</li>
        <li>Fill in your products (one row per product)</li>
        <li>Upload the completed file</li>
      </ol>
      <strong>Match logic:</strong> existing products are matched by <em>Barcode</em> first, then <em>SKU</em>. Unmatched rows create new global products.
      <p class="mb-0 mt-2 small"><strong>Global Category</strong> column: slug or exact name of a global category. Leave blank to leave the category unchanged on update (null on create).</p>
    </div>

    <!-- Template download -->
    <div class="mb-3" *ngIf="!result">
      <button class="btn btn-outline-secondary btn-sm" type="button" (click)="downloadTemplate()">
        <nb-icon icon="download-outline"></nb-icon> Download CSV Template
      </button>
    </div>

    <!-- CSV columns reference -->
    <div class="mb-3" *ngIf="!result">
      <small class="text-muted d-block mb-1"><strong>Accepted columns:</strong></small>
      <div class="column-tags">
        <span class="badge bg-secondary me-1 mb-1" *ngFor="let col of csvColumns">{{ col }}</span>
      </div>
    </div>

    <!-- File picker -->
    <div class="mb-3" *ngIf="!result">
      <label class="form-label">Select CSV file <span class="text-danger">*</span></label>
      <input type="file" class="form-control" accept=".csv" (change)="onFileSelect($event)" [disabled]="importing">
      <div class="text-danger small mt-1" *ngIf="errorMsg">{{ errorMsg }}</div>
    </div>

    <!-- Spinner -->
    <div class="text-center py-4" *ngIf="importing">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2 text-muted">Importing products, please wait…</p>
    </div>

    <!-- Results -->
    <div *ngIf="result && !importing">
      <div class="row text-center mb-3">
        <div class="col-4">
          <div class="stat-box">
            <div class="stat-value text-primary">{{ result.totalRows || 0 }}</div>
            <div class="stat-label">Total Rows</div>
          </div>
        </div>
        <div class="col-4">
          <div class="stat-box">
            <div class="stat-value text-success">{{ result.created || 0 }}</div>
            <div class="stat-label">Created</div>
          </div>
        </div>
        <div class="col-4">
          <div class="stat-box">
            <div class="stat-value text-info">{{ result.updated || 0 }}</div>
            <div class="stat-label">Updated</div>
          </div>
        </div>
      </div>

      <div class="alert alert-success" *ngIf="!result.errors?.length">
        Import completed successfully with no errors.
      </div>

      <div *ngIf="result.errors?.length" class="mb-3">
        <div class="alert alert-warning mb-2">
          <strong>{{ result.errors.length }} row(s) had errors and were skipped.</strong>
        </div>
        <div class="error-list">
          <div class="error-item" *ngFor="let e of result.errors">
            <span class="text-muted">Row {{ e.row }}:</span>
            <strong>{{ e.name || '(unnamed)' }}</strong> — {{ e.error }}
          </div>
        </div>
      </div>

      <div *ngIf="result.warnings?.length" class="mb-3">
        <div class="alert alert-light border">
          <strong>{{ result.warnings.length }} warning(s):</strong>
          <div *ngFor="let w of result.warnings" class="small text-muted">Row {{ w.row }}: {{ w.warning }}</div>
        </div>
      </div>
    </div>

  </nb-card-body>

  <nb-card-footer class="d-flex justify-content-between align-items-center">
    <span class="text-muted small" *ngIf="selectedFile && !result">
      Selected: {{ selectedFile.name }}
    </span>
    <span *ngIf="!selectedFile && !result"></span>
    <div class="d-flex gap-2">
      <button class="btn btn-outline-secondary" type="button" (click)="close()" [disabled]="importing">
        {{ result ? 'Close' : 'Cancel' }}
      </button>
      <button class="btn btn-success" type="button" (click)="import()"
        [disabled]="!selectedFile || importing || !!result">
        <span *ngIf="importing" class="spinner-border spinner-border-sm me-1"></span>
        Import
      </button>
    </div>
  </nb-card-footer>
</nb-card>
